var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.$store.getters.isLoggedIn &&
      _vm.purchase.customer.id === _vm.$store.getters.getOrganization.id &&
      _vm.purchase.private_data &&
      _vm.purchase.private_data.proposals &&
      _vm.isStatusProtocolFormedOrGreater
        ? [
            _vm.purchase.private_data.proposals &&
            _vm.purchase.private_data.proposals.length > 0
              ? [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "10" } }, [
                        _c(
                          "h2",
                          { staticClass: "grey-color font-weight-bold my-3" },
                          [_vm._v("Предложения участников")]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _vm._l(
                    _vm.purchase.private_data.proposals,
                    function (proposal, index) {
                      return _c("private-commercial-proposal-card", {
                        key: "proposal_" + index,
                        attrs: {
                          proposal: proposal,
                          "purchase-id": _vm.purchase.id,
                          "supplier-requirements":
                            _vm.purchase.supplier_requirements,
                          purchase: _vm.purchase,
                          index: index,
                          "with-rating": true,
                        },
                      })
                    }
                  ),
                ]
              : _vm._e(),
            _vm.purchase.private_data.proposals &&
            _vm.purchase.private_data.proposals.length === 0
              ? [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { md: "10" } }, [
                        _c(
                          "h2",
                          { staticClass: "grey-color font-weight-bold my-3" },
                          [_vm._v("Конкурсные заявки отсутствуют")]
                        ),
                      ]),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : _vm.purchase.status.id === "accepting" && _vm.purchase.private_data
        ? [
            _c(
              "b-row",
              [
                _c("b-col", { attrs: { md: "10" } }, [
                  _c(
                    "h2",
                    { staticClass: "grey-color font-weight-bold my-3" },
                    [_vm._v("Предложения участников")]
                  ),
                ]),
              ],
              1
            ),
            _vm.purchase.private_data.is_proposals_hidden
              ? _c("p", [
                  _vm._v(
                    "Период скрытия предложений участников в закупочной сессии наступил " +
                      _vm._s(
                        _vm.$formatDateTimeIn(
                          _vm.purchase.private_data.hide_proposals_at
                        )
                      )
                  ),
                ])
              : _c("p", [
                  _vm._v(
                    "Предложения участников будут скрыты " +
                      _vm._s(
                        _vm.$formatDateTimeIn(
                          _vm.purchase.private_data.hide_proposals_at
                        )
                      )
                  ),
                ]),
            _vm.purchase.private_data.proposals
              ? _c("b-table", {
                  staticClass: "table-atmo",
                  attrs: {
                    fields: _vm.fields,
                    items: _vm.purchase.private_data.proposals,
                    "show-empty": "",
                    small: "",
                    responsive: "",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "cell(index)",
                        fn: function (data) {
                          return [_vm._v(" " + _vm._s(data.index + 1) + " ")]
                        },
                      },
                      {
                        key: "cell(status)",
                        fn: function (data) {
                          return [
                            _vm._v(" " + _vm._s(data.item.status.title) + " "),
                            data.item.is_my_proposal
                              ? _c("span", {
                                  domProps: { textContent: _vm._s("(Моё)") },
                                })
                              : _vm._e(),
                          ]
                        },
                      },
                      {
                        key: "cell(created_at)",
                        fn: function (data) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$formatDateTime(data.item.created_at)
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                      {
                        key: "cell(supplier)",
                        fn: function (data) {
                          return [
                            _c("span", {
                              domProps: {
                                textContent: _vm._s(
                                  `Поставщик ${data.index + 1}`
                                ),
                              },
                            }),
                          ]
                        },
                      },
                      {
                        key: "empty",
                        fn: function () {
                          return [
                            _c("div", { staticClass: "w-100 text-center" }, [
                              _vm._v("Нет поданных предложений"),
                            ]),
                          ]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1215650046
                  ),
                })
              : _vm._e(),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }